import type { HomePlacement, HomeSize } from '@/components/home/homeLayout';
export const HOME_PATH = '/design/home';
export const SMALL_SIZES: readonly HomeSize[] = [
  { columns: 3, rows: 1 },
  { columns: 6, rows: 1 },
  { columns: 6, rows: 2 },
];
export const MEDIUM_SIZES: readonly HomeSize[] = [
  { columns: 6, rows: 1 },
  { columns: 6, rows: 2 },
  { columns: 9, rows: 2 },
  { columns: 12, rows: 2 },
  { columns: 12, rows: 3 },
  { columns: 12, rows: 4 },
];
export const INITIAL_HOME_LAYOUT: HomePlacement[] = [
  { id: 'reviews', column: 0, row: 0, columns: 3, rows: 1 },
  { id: 'balance', column: 3, row: 0, columns: 3, rows: 1 },
  { id: 'queue', column: 6, row: 0, columns: 6, rows: 2 },
  { id: 'note', column: 0, row: 1, columns: 6, rows: 1 },
];
